import DatePicker, { registerLocale } from 'react-datepicker'
import { ru } from 'date-fns/locale'
import { Stack, Text, ActionIcon, Group } from '@mantine/core'
import 'react-datepicker/dist/react-datepicker.css'
import '../task-modal/task-modal-datepicker.css' // переиспользуем macOS-style CSS overrides

registerLocale('ru', ru)

interface Props {
  label?: string
  description?: string
  value: string | null // YYYY-MM-DD
  onChange: (v: string | null) => void
  placeholder?: string
  required?: boolean
}

/**
 * Date-only пикер (без времени) на base react-datepicker с macOS-style CSS из
 * task-modal-datepicker.css. Используется для birth_date контактов и
 * next_follow_up_at проектов. Хранит/отдаёт YYYY-MM-DD строку.
 */
export function DateOnlyPicker({ label, description, value, onChange, placeholder = 'не задана', required }: Props) {
  const selected = value ? new Date(value) : null

  function handleChange(d: Date | null) {
    if (!d) {
      onChange(null)
      return
    }
    // Локальный формат YYYY-MM-DD (не UTC — иначе сдвиг по TZ)
    const pad = (n: number) => String(n).padStart(2, '0')
    const s = `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`
    onChange(s)
  }

  return (
    <Stack gap={4}>
      {label && (
        <Text size="sm" fw={500}>
          {label}
          {required && <span style={{ color: '#fa5252' }}> *</span>}
        </Text>
      )}
      <Group gap="xs" wrap="nowrap" align="center">
        <DatePicker
          selected={selected}
          onChange={handleChange}
          dateFormat="d MMMM yyyy"
          locale="ru"
          placeholderText={placeholder}
          isClearable={false} /* очищаем кнопкой справа — она компактнее */
          className="rdp-input"
          popperPlacement="bottom-start"
          showMonthDropdown
          showYearDropdown
          dropdownMode="select"
          /* Для ДР важно — нужно выбирать год вручную (1985 и т.п.) */
        />
        {value && (
          <ActionIcon variant="subtle" color="gray" onClick={() => onChange(null)} title="Очистить">
            ×
          </ActionIcon>
        )}
      </Group>
      {description && (
        <Text size="xs" c="dimmed">
          {description}
        </Text>
      )}
    </Stack>
  )
}
